export default __webpack_public_path__ + "src/images/galleries/0/btn_next-c91b95.png";